<template>
  <div class="why-cloud-enterprise">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">为什么是云企业？</div>
        <div class="double-arrow"></div>
        <FadeInBox>
          <div class="module-title text-primary">无需重构组织架构，即可嫁接平台核心能力</div>
          <div class="module-subtitle">高效链接项目全周期资源，实现商业价值突破，解决新基建领域长期存在的经营壁垒</div>
        </FadeInBox>
      </div>
    </div>
  </div>
</template>

<script>
import FadeInBox from './FadeInBox.vue';

export default {
  components: { FadeInBox },
};
</script>

<style lang="less" scoped>
.why-cloud-enterprise {
  padding: 64px 0;
  background-color: #fff;
  .double-arrow {
    margin: 24px 0;
  }
}
</style>
